import EditIcon from '@mui/icons-material/Edit';

export const FORM_ACTION_BUTTONS = [
  {
    id: 'copy',
    tooltip: 'کپی لینک فرم',
    label: 'کپی لینک فرم',
    icon: <img src="./assets/images/copy-link.svg" alt="" style={{ width: '32px', height: '32px' }} />,
    mobileIcon: <img src="./assets/images/copy-link.svg" alt="" style={{ width: '24px', height: '24px' }} />,
    onClick: (id, actions) => actions.copyFormLinkWrapper(id),
    visibleIn: ['AllForm', 'Favorite']
  },
  {
    id: 'fill',
    tooltip: 'پر کردن فرم',
    label: 'پر کردن فرم',
    icon: <img src="./assets/images/fillForm.svg" alt="" style={{ width: '32px', height: '32px' }} />,
    mobileIcon: <img src="./assets/images/fillForm.svg" alt="" style={{ width: '24px', height: '24px' }} />,
    onClick: (id, actions) => actions.handleGetFormDetailsWrapper(id, 'fillForm'),
    visibleIn: ['AllForm', 'Favorite']
  },
  {
    id: 'edit',
    tooltip: 'ویرایش',
    label: 'ویرایش',
    icon: <EditIcon fontSize="large" />,
    mobileIcon: <EditIcon fontSize="medium" />,
    onClick: (id, actions) => actions.handleGetFormDetailsWrapper(id, 'edit'),
    visibleIn: ['AllForm', 'Favorite']
  },
  {
    id: 'responses',
    tooltip: 'لیست پاسخ های فرم',
    label: 'لیست پاسخ های فرم',
    icon: <img src="./assets/images/list-response.svg" alt="" style={{ width: '32px', height: '32px' }} />,
    mobileIcon: <img src="./assets/images/list-response.svg" alt="" style={{ width: '24px', height: '24px' }} />,
    onClick: (id, actions) => actions.handleGetListResponseFormWrapper(id),
    visibleIn: ['AllForm', 'Favorite']
  }
];

